import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { forEach, find } from 'lodash';

import template from '../../../templates/PageLayout/Popups/Permissions.rt';
import { getPermissions, updatePermissions } from '../../../actions/permissions';

const mapStateToProps = state => ({
  allRights: state.permissions.data.allRights,
  permissions: state.permissions.data,
  concatPermissions: state.permissions.data.userRights.personalRights,
  updateSuccess: state.permissions.updateSuccess,
  searchText: state.permissions.searchText
});

const mapDispatchToProps = { getPermissions, updatePermissions };

class Permissions extends Component {
  constructor(props){
    super(props);
    this.state = {
      permissions: {
        userRights: {},
        allRights: []
      },
      newPersonalRights: [],
      firstLoad: true,
      showPopup: props.showPopup || false,
      user: {}
    }
  }

  componentDidMount() {
    if (this.props.useRedux) {
      this.props.getPermissions(this.props.user.id, this.props.entityType, this.props.fabricatorId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.firstLoad && nextProps.updateSuccess) {
      this.handleClose();
      return;
    }

    if (nextProps.showPopup && this.state.firstLoad) {
      this.setState({
        firstLoad: false,
        showPopup: true,
        user: nextProps.user
      });
      this.props.getPermissions(nextProps.user.id, nextProps.entityType, nextProps.fabricatorId);
    }
    else if (!nextProps.showPopup) {
      this.setState({
        firstLoad: true,
        showPopup: false
      })
    } else if (nextProps.permissions) {

      forEach(nextProps.permissions.allRights, p => {
        const userP = find(nextProps.concatPermissions, cp => cp.protectedAreaId === p.id);
        if (userP) {
          p.accessRights = userP.accessRights;
          p.enabledLevel = userP.enabledLevel;
        }
      });

      this.setState({
        permissions: nextProps.permissions,
        concatPermissions: nextProps.concatPermissions
      })
    }
  }

  setPermissions = (searchText) => {
    const permissions = {...this.state.permissions};
    permissions.allRights = this.props.allRights.filter((right) => {
      return right.description.toLowerCase().includes(searchText.toLowerCase());
    });
    this.setState({
      permissions
    });
  };

  updateNewPersonalRights = (newPersonalRights, right) => {
    const newRightIndex = newPersonalRights.findIndex(newRight => newRight.protectedAreaId === right.protectedAreaId);
    newRightIndex > -1 ? newPersonalRights.splice(newRightIndex, 0, right) : newPersonalRights.push(right);
    return newPersonalRights
  };

  changeAllPermissions = (type) => {
    let newPersonalRights = [...this.state.newPersonalRights];
    const permissions = {...this.state.permissions};

    permissions.allRights.forEach((permission) => {
      const right = this.state.concatPermissions.find(right => right.protectedAreaId === permission.id);
      if (right && (right.accessRights !== type)) {
        newPersonalRights = this.updateNewPersonalRights(newPersonalRights, right);
        right.accessRights = type;
        permission.accessRights = right.accessRights;
      }
    });

    this.setState({
      permissions,
      newPersonalRights
    });
  };

  handlePermissionChange = (permissionId, type) => {
    let newPersonalRights = [...this.state.newPersonalRights];
    const permissions = {...this.state.permissions};

    console.log(this.state.permissions);
    const right = this.state.concatPermissions.find(right => right.protectedAreaId === permissionId);

    if (right.accessRights !== type) {
      newPersonalRights = this.updateNewPersonalRights(newPersonalRights, right);
      right.accessRights = type;
      const p = find(permissions.allRights, _ => _.id === permissionId);
      p.accessRights = right.accessRights;
    }

    this.setState({
      permissions,
      newPersonalRights
    });
  };

  getPermissionText = (description) => {
    if (this.props.searchText) {
       console.log("description.split(this.props.searchText)", description.split(this.props.searchText));
    }
    return description
  };

  handleSave = () => {
    this.setState({
      newPersonalRights: []
    });
    this.props.updatePermissions({
      entityId: this.props.user.id,
      fabricatorId: this.props.fabricatorId,
      entityType: this.props.entityType,
      inheritedRights: [],
      personalRights: this.state.newPersonalRights
    });
  };

  handleClose = () => {
    this.setState({
      firstLoad: true,
      newPersonalRights: [],
      permissions: {
        userRights: {},
        allRights: []
      }
    });
    this.props.handleClosePopup('permissions' + this.props.entityType);
  };

  render() {
    return template.apply(this);
  }
}

Permissions.propTypes = {
  permissions: PropTypes.object,
  showPopup: PropTypes.bool,
  user: PropTypes.object,
  handleClosePopup: PropTypes.func.isRequired,
  entityType: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Permissions);
